// extracted by mini-css-extract-plugin
export var standaloneTable = "_21-0";
export var standaloneTableWithBodyFill = "_21-1";
export var withExtraHeader = "_21-2";